import { render } from "./ProductCardSkeleton.vue?vue&type=template&id=1727441b"
import script from "./ProductCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__